import type { FaireProductEntity } from "../../entity_types/product";

export const p_zbmat5yyy2: FaireProductEntity = {
  token: "p_zbmat5yyy2",
  type: "product",
  name: "The Book Was Better Tee - White",
  brandToken: "b_dfu92850",
  brandName: "Pippi Post",
  imageUrl:
    "https://cdn.faire.com/fastly/8203b6c4ffa574a86bcbebcd88e583c94fa637562cf9527ef7b6b84ffa26b266.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/70f0a903db8efed798b72c30e83e46d03b96136cc14cd700a8aa629cd77ec4e6.jpeg",
    "https://cdn.faire.com/fastly/4f93bb005cb3bb757d0f6af5ad29cf59edb3c80317c4c2b5e3dc9caddc50e39c.jpeg",
    "https://cdn.faire.com/fastly/1a4e6e0e3add48f5d70ab81e87cc5d5d8b6aa97412b87966a14a2428c10a2ebb.jpeg",
    "https://cdn.faire.com/fastly/ba59f75a3dcff3e60691b26ac2d746c5f63a541375d7f11d42f386cc605901e0.jpeg",
  ],
  priceDollars: 22.05,
  description:
    "All of us bookish folks know it is true no matter the book... from Harry Potter to The Chronicles of Narnia, the book is always better. This super soft graphic t-shirt makes the perfect gift for mother's day or for anyone who loves to read books. Be sure to checkout our book club collection for more coordinating tops and accessories!\n\nMaterial: 100% Cotton\nColor: White\nFit: Unisex\nBrand: Comfort Colors®\nDesign: The Book Was Better\nCare Instructions: Machine wash cold inside out, gentle cycle with like colors. Hang to dry.",
  tags: [],
  msrpDollars: 44.09,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:12:01.843Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
